import Vue from 'vue'
import axios from 'axios'
import { encode } from 'querystring-es3'

// Core Constants
import { APP_API_PATH } from '@/core/constants'

// Set axios defaults
axios.defaults.baseURL = APP_API_PATH
axios.defaults.transformRequest = [(data, headers) => {
  headers["X_CSRF_TOKEN"] = App.settings.CSRFToken
  return encode(data)
}]

// Add a global variable to access axios
Vue.prototype.$service = axios

export default axios